<template>
    <div class="container" style="width: 100%;">
        <ValidationProvider
            style="width: 100%;  margin: 48px 0px 0px;"
            name="Amount"
            :rules="rules"
            v-slot="{ errors, classes }"
        >
            <!-- <div class="heading" style="padding-bottom: 48px;">
                Select your partial withdrawal amount
            </div> -->
            <div class="heading" :class="classes">
                &#x20B9;<input id="inputAmount" type="tel" ref="input" v-model="withdrawAmount" v-on:input="adjustInput" :placeholder="placeholder"/>
            </div>
            <div class="errorText">{{ errors[0] }}</div>
            <div class="small centerAlign">
                <div>
                    Your investment has been divided among various loans, so withdrawals will be limited to the
                    nearest lower range of the sum of the principal outstanding for each loan.
                </div>
            </div>
        </ValidationProvider>

        <div v-if="isAmountLoading" style="text-align: center; padding: 48px;">
            <v-progress-circular
                indeterminate
                color="grey"
                :size="36"
            ></v-progress-circular>
        </div
        >
        <div v-if="checkVisibility" class="centerAlign" style="padding-top:48px; line-height: 1.1">
            <span>
                Select your partial withdrawal amount
            </span>
        </div>
        <div class="options" v-if="checkVisibility">
            <div class="optionWrapper" v-if="getLowerBound !== '--'">
                <div class="option" @click="selectAmount(lowerBound, 'isLower')" :class="{ active: selectedValue === 'isLower'}">
                    <span v-if="isAmountLoading">
                        <v-progress-circular
                            indeterminate
                            color="grey"
                            :size="20"
                        ></v-progress-circular>
                    </span>
                    <span v-else>
                        &#x20B9;{{ getLowerBound | localeAmountPaisaToRupee }}
                    </span>
                </div>
            </div>
            <div class="optionWrapper" v-if="getUpperBound !== '--'">
                <div class="option" @click="selectAmount(upperBound, 'isUpper')" :class="{ active: selectedValue === 'isUpper'}">
                    <span v-if="isAmountLoading">
                        <v-progress-circular
                            indeterminate
                            color="grey"
                            :size="20"
                        ></v-progress-circular>
                    </span>
                    <span v-else>
                        &#x20B9;{{ getUpperBound | localeAmountPaisaToRupee }}
                    </span>
                </div>
            </div>
        </div>
        <div style="padding-top: 50px; text-align: center;" v-if="checkVisibility">
            <button class="withdrawButton" @click="confirmWithdrawal" :disabled="isDisabled">
                Withdraw
            </button>
        </div>
        <v-snackbar v-model="snackbar" app timeout="-1">
            {{ snackbarMessage }}
            <template v-slot:action="{ attrs }">
                <v-btn
                color="red"
                text
                v-bind="attrs"
                @click="snackbar = false"
            >
                Close
            </v-btn>
            </template>
        </v-snackbar>
    </div>
</template>

<script>
import LenderService from '@/services/lenderService'

export default {
    name: 'PartialWithdrawal',
    props: {
        withdrawalAmount: {
            type: Number
        },
        portfolio: {
            type: Object
        },
        withdrawType: {
            type: String,
            default: 'partial'
        }
    },
    data () {
        return {
            amount: null,
            selectedPortfolio: null,
            lowerBound: 0,
            upperBound: 0,
            selectedAmount: 0,
            isAmountLoading: false,
            timeout: null,
            selectedValue: null,
            isDisabled: true,
            rules: '',
            placeholder: 'Enter the amount',
            minAmount: 1,
            snackbar: false,
            snackbarMessage: null
        }
    },
    mounted () {
        this.$refs.input.focus()
        if (this.withdrawalAmount < 500000) {
            this.rules = `amountValidationLocale:${this.withdrawalAmount / 100},1|required`
        } else {
            this.minAmount = 5000
            this.rules = `amountValidationLocale:${this.withdrawalAmount / 100},5000|required`
        }
        this.selectedPortfolio = this.portfolio
        // this.amount = this.withdrawalAmount / 100
        const event = document.getElementById('inputAmount')
        event.style.width = '13ch'
    },
    computed: {
        withdrawAmount: {
            get () {
                if (this.amount) {
                    return this.amount.toLocaleString('en-IN', { useGrouping: true }) || 0
                }
                return null
            },
            set (newValue) {
                // if (newValue.length === 1 && this.amount) {
                //     console.log('1')
                //     this.amount = 0
                // }
                const temp = parseFloat(newValue.replaceAll(',', ''))
                console.log('temp', temp)
                if (temp <= 5000000) {
                    this.amount = temp || 0
                } else {
                    this.amount = 0
                    this.isAmountLoading = false
                }
            }
        },
        getUpperBound () {
            if ((this.upperBound / 100) < this.amount || this.upperBound === this.lowerBound) {
                return '--'
            }
            return this.upperBound
        },
        getLowerBound () {
            if (this.lowerBound / 100 > 0) {
                return this.lowerBound
            }
            return '--'
        },
        checkVisibility () {
            return (this.amount >= this.minAmount) && (this.amount < this.withdrawalAmount) && (this.lowerBound || this.upperBound)
        }
    },
    methods: {
        confirmWithdrawal () {
            // call withdrawal event with selected amount
            if (this.withdrawType === 'locked') {
                this.sendRequest()
            } else {
                let option = 'partial'
                if (this.selectedAmount === this.withdrawalAmount) {
                    option = 'full'
                }
                this.$emit('sendWithdrawalRequest', this.selectedAmount, option)
            }
        },
        adjustInput (event) {
            // debounce(() => {
            if (!this.amount) {
                const event = document.getElementById('inputAmount')
                event.style.width = '13ch'
            } else if (event.target.value.length === 0) {
                event.target.style.width = '13ch'
            } else if (event.target.value.length === 1) {
                event.target.style.width = '30px'
            } else {
                console.log('event.target.value', event.target.value)
                event.target.style.width = (event.target.value.length) + 1 + 'ch'
            }
            this.debounceData()
            // })
        },
        debounceData () {
            if (this.timeout) {
                clearInterval(this.timeout)
            }
            this.timeout = setTimeout(() => {
                this.selectedValue = null
                this.isDisabled = true
                this.getWithdrawalSummary()
            }, 1000)
        },
        getWithdrawalSummary () {
            if (this.amount <= (this.withdrawalAmount / 100) && this.amount >= this.minAmount) {
                this.isAmountLoading = true
                const queryString = 'portfolioId=' + this.portfolio.portfolioId + '&withdrawalAmount=' + (this.amount * 100).toFixed(0) + '&type=' + this.withdrawType
                LenderService.getWithdrawalSummary(queryString).then((response) => {
                    if (response.status === 200) {
                        this.selectedPortfolio = response.data.portfolio
                        this.withdrawableAmount = response.data.withdrawableAmount
                        console.log('check')
                        if (this.selectedPortfolio.validAmount >= 500000 || this.withdrawType === 'locked') {
                            this.lowerBound = this.selectedPortfolio.validAmount
                        } else {
                            this.lowerBound = 0
                        }
                        this.upperBound = this.selectedPortfolio.upperLimit
                        this.isAmountLoading = false
                    } else if (response.status === 400) {
                        this.snackbar = true
                        this.snackbarMessage = 'Please enter a valid amount!'
                        this.lowerBound = 0
                        this.upperBound = 0
                    } else {
                        this.lowerBound = 0
                        this.upperBound = 0
                    }
                })
            } else {
                this.lowerBound = 0
                this.upperBound = 0
            }
        },
        selectAmount (amount, selected) {
            console.log('amt', amount)
            if (amount > 0 && amount <= this.withdrawalAmount) {
                this.selectedValue = selected
                this.selectedAmount = amount
                this.isDisabled = false
            }
        },
        sendRequest () {
            const payload = {
                withdrawalAmount: this.selectedAmount / 100,
                portfolioId: this.portfolio.portfolioId
            }
            this.$store.commit('isLoading')
            LenderService.sendLockedPortfolioWithdrawalRequest(payload).then((response) => {
                console.log('response', response)
                if (response.status === 200) {
                    this.$emit('goForward')
                }
                this.$store.commit('isNotLoading')
            })
        }
    }
}
</script>

<style scoped>
    .container {
        width: 40%;
        padding-top: 70px
    }
    .heading {
        font-weight: 700;
        font-size: 22px;
        line-height: 25px;
        color: #232323;
        text-align: center;
        margin: 48px 0px 0px;
    }

    .options {
        display: flex;
        justify-content: space-evenly;
        padding-top: 36px;
    }

    .option {
        background: #F2F7FF;
        border-radius: 26px;
        padding: 6px 13px;
        font-weight: 700;
        font-size: 13px;
        color: #4F4F4F;
        letter-spacing: 0.035em;
        margin: 0px 23px;
        cursor: pointer;
    }

    .active {
        background: #002FA7;
        color: #FFFFFF
    }

    button {
        padding: 11px 24px;
        border-radius: 6px;
        letter-spacing: 0.005em;
        font-size: 14px;
        line-height: 150%;
        font-weight: 600;
        width: 70%;

    }

    .withdrawButton {
        background: #002FA7;
        color: #FFFFFF;
    }

    .small {
        font-size: 11px;
        line-height: 1;
        color: #8c8c8c;
        padding-top: 16px;
    }

    input[type=tel]:focus {
        border: none;
        background-color: none;
        outline: 0;
        /* min-width: 50px;
        max-width: 240px; */
    }

    input[type=tel] {
        caret-color: #007AFF;
        min-width: 50px;
    }

    button:disabled {
        background-color: grey;
    }
    /* button:disabled,
    button[disabled]{
        border: 1px solid #999999;
        background-color: #cccccc;
          color: #666666;
    } */

    @media (max-width: 480px) {
        .container {
            width: 100%;
        }

        .heading {
            margin: 0px !important;
        }
    }

    .optionWrapper {
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .errorText {
        color: #e45f5f !important;
        font-size: 12px;
        text-align: center;
    }

    .centerAlign {
        text-align: center;
    }
</style>
